import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { FdtScriptImporterService } from 'src/app/service/fdt-script-importer.service';
import { RenderOtxCandidateService } from 'src/app/service/render-otx-candidate.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
@Component({
  selector: 'app-main-fdrs',
  templateUrl: './main-fdrs.component.html',
  styleUrls: ['./main-fdrs.component.scss']
})
export class MainFdrsComponent implements OnInit {

  progressbar:boolean=false;
  hostAddr = "127.0.0.1";
  AUTH_TOKEN = '';//'AuthToken';
  networkTestResult: any;
  public userId: any;
  public sessionId:any;
  public qidRes:any;
  public res:any;
  public invinnumber=''
  public isNetwork=false;
  tokenObj:any;
  language: any;
  countryCode: any;
  queueId: any;

  constructor(private service: ApifirstService,
    private fdtScriptService: FdtScriptImporterService,
    private rpcClientService: RpcClientService,
    private renderOtxCandidateService: RenderOtxCandidateService,
    private fdrsClientService: FdrsClientService) {
    rpcClientService._networkResult$.subscribe((error) => {
      this.networkTestResult = error;
    })
  }

  ngOnInit(): void {  
    
    this.service.isNetorkTest.subscribe(data =>{
      this.isNetwork=data;
    })
    if(this.isNetwork){
    this.service.isProgressBar.subscribe(data =>{
      this.progressbar=data;
    })
  }
    this.service.tokenObj.subscribe((data) => {
  
    const token=localStorage.getItem("token")
    console.log('token',token)
    this.service.tokenObj.subscribe((data)=>{
this.tokenObj=data
    })
    this.service.userId.subscribe((data)=>{
      this.userId=data
          })
    let language= this.tokenObj.language
    let country =this.tokenObj.country
    let vin=this.tokenObj.vin
    let usertype=this.tokenObj.userType
    let userId=this.userId
    let userName=this.tokenObj.username
    let locale =language+"_"+country
    this.res = data;
    this.invinnumber = this.res.vin
  })

    this.sessionId=localStorage.getItem("sessionID")
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    const req={
        "userId":this.userId,
        "sessionSource":"gfdrs",
        "vin":this.invinnumber,
        "fdrsId":22
    }
  
    this.fdrsClientService.initFdrsClient("");
     
    //this.fdtScriptService.scriptLoader("");
  }

  startTest() {
    this.progressbar=true;
    this.rpcClientService.runNetworkTest("", "");
  }

  renderOtxCandidate() {
    this.service.tokenObj.subscribe((data)=>{
      this.res = data;
      this.invinnumber = this.res.vin
      this.language= this.res.language.toLowerCase()
      this.countryCode =this.res.country
      this.sessionId=localStorage.getItem("sessionID")

      let reqBodyForSessionId=
        {
          "sessionId" : this.sessionId
        }
     console.log("req", this.language, this.countryCode, reqBodyForSessionId);
     this.getQueueId(this.language, this.countryCode, reqBodyForSessionId);
    })
  }

  getQueueId(language: string, countryCode: string, reqBodyForSessionId: any) {
    this.service.queueIdRes(language, countryCode, reqBodyForSessionId,this.queueId,"").subscribe((data) => {
      this.qidRes = data;
      this.renderOtxCandidateService.tryFDTConnection(this.queueId,this.qidRes );

  })
  }

}
